// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"e5c90db1","236":"6df5a6c1","269":"c43e7491","977":"4bd61622"}[chunkId] + ".chunk.js";
};